import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const GA_MEASUREMENT_ID = "G-BBR8B8YQMY";

/**
 * Tracks client-side page views in React Router for Google Analytics 4 (GA4).
 * - Tracks page views on initial load and client-side route changes.
 * - Avoids duplicate page_view events by keeping track of the last dispatched path.
 * - Synchronizes with dynamic document.title updates from `<Seo />`.
 * - Enables GA4 DebugView when ?debug_mode=true or debug_mode=1 is present in the URL.
 */
export function RouteChangeTracker() {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    // Small timeout ensures that <Seo /> component's useEffect has completed
    // and document.title is fully updated for the new route.
    const timer = setTimeout(() => {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        const urlParams = new URLSearchParams(window.location.search);
        const isDebug =
          urlParams.has("debug_mode") ||
          urlParams.has("_dbg") ||
          window.__GA_DEBUG__ === true;

        window.gtag("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href,
          page_path: currentPath,
          send_to: GA_MEASUREMENT_ID,
          ...(isDebug ? { debug_mode: true } : {}),
        });

        lastTrackedPath.current = currentPath;
      }
    }, 120);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}

export default RouteChangeTracker;
